import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const PROOF_WALL_MIN = 3;

// Shown for 1–2 published stories; from 3 on, FirstListenersWall turns them into named quote cards.
export default function ListenerStories() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/listener-stories").then((r) => setStories(r.data.stories || [])).catch(() => {});
  }, []);

  if (!stories.length || stories.length >= PROOF_WALL_MIN) return null;

  return (
    <section className="mt-24 max-w-4xl" data-testid="listener-stories">
      <p className="font-sans uppercase tracking-[0.28em] text-xs text-terracotta mb-6">Listener stories</p>
      <h2 className="font-serif text-2xl md:text-3xl text-bone-100 mb-10 leading-tight">
        In their own words.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {stories.map((s) => (
          <figure key={s.id} className="border border-obsidian-600 p-6" data-testid={`listener-story-${s.id}`}>
            <blockquote className="font-serif italic text-lg text-bone-200 leading-relaxed">
              &ldquo;{s.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              {s.avatar_url ? (
                <img src={s.avatar_url} alt={s.first_name} className="h-9 w-9 rounded-full object-cover" />
              ) : (
                <span className="h-9 w-9 rounded-full border border-terracotta/60 flex items-center justify-center font-serif text-bone-100">
                  {s.first_name[0]}
                </span>
              )}
              <span className="font-sans text-xs uppercase tracking-[0.2em] text-bone-400">
                {s.first_name}
                {s.outcome ? ` · ${s.outcome}` : ""}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
